import { SourceEditorEdits } from '../components/source-editor/types'
import { CreationToolFrame } from '../types'

const getFramesWithEdits = (
    frames: CreationToolFrame[],
    duration: number,
    edits: SourceEditorEdits
): CreationToolFrame[] => {
    let editedFrames = [...frames]

    if (edits.trim) {
        const totalFrames = editedFrames.map(f => f.frameCount || 1).reduce((a, b) => a + b)
        const startFrame = Math.floor((edits.trim.start / duration) * totalFrames)
        const endFrame = Math.floor((edits.trim.end / duration) * totalFrames)
        editedFrames = editedFrames.slice(startFrame, endFrame)
    }

    if (edits.crop) {
        editedFrames = editedFrames.map(frame => {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            canvas.width = edits.crop!.width
            canvas.height = edits.crop!.height
            context?.drawImage(frame.canvas, -edits.crop!.x, -edits.crop!.y)
            return { ...frame, canvas }
        })
    }

    if (edits.frames && edits.frames.length) {
        editedFrames.forEach((frame, i) => {
            const watermarkFrame = i % edits.frames!.length
            const { canvas: watermarkCanvas } = edits.frames![watermarkFrame]
            frame.canvas.getContext('2d')?.drawImage(watermarkCanvas, 0, 0)
        })
    }

    return editedFrames
}

export default getFramesWithEdits
